import { render, staticRenderFns } from "./u-txt-default.vue?vue&type=template&id=b74cb6cc&scoped=true&"
import script from "./u-txt-default.vue?vue&type=script&lang=js&"
export * from "./u-txt-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74cb6cc",
  null
  
)

export default component.exports